<template>
  <div class="tables-basic">
    <div v-if="loading || subscriptionLoading" class="page-loading-container">
      <b-spinner label="Loading..." ></b-spinner>
    </div>
    <div v-else>

      <h2 class="page-title">Website Api Keys</h2>
      <b-alert show variant="secondary">Api Keys allows you to trigger an audit for your website automatically.<br>
      <a href="https://docs.pagewatch.dev/guide/api.html">See Documentation</a></b-alert>

      <b-row >
        <b-col>
          <Widget
                  :title="`${activeSite.url}`"
          >
            <div class="table-responsive" v-if="!(user.plan === 'free' || user.plan === 'basic')">
              <table class="table table-hover" >
                <thead>
                <tr>
                  <th scope="col" width="90%">Key</th>
                  <th scope="col">Revoke</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="key in apiKeys">
                  <td>
                    <a href="#here" v-if="!key.revealed" @click="$set(key, 'revealed', true)">Reveal Key</a>
                    <span v-else>{{key.key}}</span><p>
                    <small style="color:gray">Generated {{key.created |  moment('from')}}</small></p>
                  </td>
                  <td>  <b-button variant="warning" size="sm" style="white-space: nowrap;" @click="revokeKey(key.key)">Revoke</b-button></td>
                </tr>
                </tbody>
              </table>
              <b-button @click.prevent="generateKey()" size="sm" style="white-space: nowrap;">Generate Key</b-button>
            </div>
            <div v-else>
            <b-alert show variant="warning">Api keys require a Business or Pro subscription.</b-alert>
            <demo-notice  button="Update Subscription" :angleRight="false"></demo-notice>
            </div>

          </Widget>
        </b-col>
      </b-row>

    </div>
  </div>
</template>

<script>
  import Widget from '@/components/Widget/Widget';
  import DemoNotice from "@/components/DemoNotice/DemoNotice";

  import gql from "graphql-tag";

  import { mapState } from 'vuex';
  import axios from "axios";
  export default {
    name: 'Tables',
    components: { Widget, DemoNotice },
    apollo: {
      $subscribe: {

        subscription: {
          query() {
            return gql`subscription {
                  websites_subscription {
                    state
                    websites_plan{
                      name
                      display_name
                      options
                    }
                  }
          }`
          },
          skip () {
            return false;
          },
          result (data) {
            this.subscription = data.data.websites_subscription[0];
            this.plan = this.subscription.websites_plan;
            this.subscriptionLoading = false;

            this.loading = false;
          },

        },

      },
    },
    data() {
      return {
        websites: [],
        apiKeys: [],
        plan: {},
        toastOptions: {
          theme: 'dark',
          position: 'bottomLeft',
        },
        loading: true,
        subscriptionLoading: true,
      };
    },
    computed: {
      ...mapState({activeSite: 'activeSite', user: 'user'}),
    },
    metaInfo: {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Api Keys - PageWatch.dev',
      // all titles will be injected into this template
    },
    methods: {
      revokeKey(key){
        axios
                .delete(`websites/keys?id=${this.activeSite.uuid}&key=${key}`)
                .then(
                        response => {
                          this.loading = false;
                          this.apiKeys = response.data.keys;
                          return true;
                        },
                        _response => {
                          console.warn(_response);
                          return false;
                        }
                );
      },
      generateKey(){
        axios
                .post(`websites/keys`, {
                  id: this.activeSite.uuid,
                })
                .then(
                        response => {
                          this.loading = false;
                          this.apiKeys = response.data.keys;
                          this.apiKeys[0].revealed = true;
                          return true;
                        },
                        _response => {
                          console.warn(_response);
                          return false;
                        }
                );
      },
      getKeys(){
        axios
                .get(`websites/keys?id=${this.activeSite.uuid}`)
                .then(
                        response => {
                          this.loading = false;
                          this.apiKeys = response.data.keys;
                          return true;
                        },
                        _response => {
                          console.warn(_response);
                          return false;
                        }
                );

      },
    },
    created() {
      this.$watch("$route",() => {
        this.currentPage = this.$route.query.page || 1;
        }, {
        immediate: true
      });
    },
    watch: {
      'activeSite': function () {
        this.getKeys();
      }
    },
    mounted(){
      this.getKeys();
    }
  };
</script>

<style src="./Api.scss" lang="scss" scoped />
<style lang="scss">
  .link-redirect {
    font-size:9pt;
    color:gray;
    padding:4px;
  }
  .link-status-redirect{
    color:red;
    font-size:9pt;
    padding:4px;
  }
  .link-entry{
    max-width:580px;
    overflow:auto;
  }
  .broken-link-preview-image {
    border-radius: 50%;
    max-width: 250px;
    box-shadow: #bdc4e0 0px 0px 20px;
  }
</style>
